import { ReactNode } from 'react'
import Styles from './SegmentedItemWithDescription.module.scss'
import cx from 'classnames'

interface SegmentedItemWithDescriptionProps {
  label: ReactNode
  description: ReactNode
  active?: boolean
}

export const SegmentedItemWithDescription = ({ label, description, active }: SegmentedItemWithDescriptionProps) => {
  return (
    <div className={Styles.container}>
      <div className={Styles.label}>{label}</div>
      <div
        className={cx(Styles.description, {
          [Styles.active]: active,
        })}
      >
        {description}
      </div>
    </div>
  )
}
